const { SEPHORA_URL: { DESKTOP } } = require('components/constants');
const { SpaTemplatesInfo } = require('constants/SpaTemplatesInfo');
const bccUtil = require('utils/BCC');
const LocationUtils = require('utils/Location');
const store = require('Store');
const UrlUtils = require('utils/Url');
const UserActions = require('actions/UserActions');
const PageTemplateType = require('constants/PageTemplateType');


const SpaUtils = {
    replaceContentAreaTargeters: function (currentData = {}, newData = {}) {
        let allPageTargeterNames = Sephora.targetersToInclude.substr('?includeTargeters='.length);
        allPageTargeterNames = decodeURIComponent(allPageTargeterNames).split(',');

        // remove old content area targeters
        const currentTargeterNames = bccUtil.extractTargeters(currentData);
        for (const targeterName of currentTargeterNames) {
            const index = allPageTargeterNames.indexOf(targeterName);
            if (index !== -1) {
                allPageTargeterNames.splice(index, 1);
            }
        }

        // add new content area targeters
        const newTargeterNames = bccUtil.extractTargeters(newData);
        allPageTargeterNames = allPageTargeterNames.concat(newTargeterNames);
        Sephora.targetersToInclude = bccUtil.buildTargetersQueryParams(allPageTargeterNames);
    },

    updateUserFull: function (data, productPageData = {}, options = {}) {
        const currentUser = Sephora.Util.getCurrentUser();
        const basketCache = Sephora.Util.getBasketCache(currentUser);
        const userInfoCache = Sephora.Util.getUserInfoCache();

        if (Sephora.Util.shouldGetUserFull(basketCache, currentUser, userInfoCache)) {
            store.dispatch(UserActions.getUserFull(
                productPageData,
                undefined,
                undefined,
                undefined,
                options.hideLoader || false
            ));
        } else if (Sephora.Util.shouldGetTargeters()) {
            let apiToInclude;
            if (Sephora.Util.shouldGetTargetedPromotion()){
                apiToInclude = 'targetersResult,targetedPromotion';
            } else {
                apiToInclude = 'targetersResult';
            }
            store.dispatch(UserActions.getUserFull(
                productPageData,
                null,
                { includeApis: apiToInclude },
                undefined,
                options.hideLoader || false
            ));
        }
    },

    resetCertona: function () {
        require('services/Certona')();
    },

    resetDigitalData: function() {
        digitalData.page.renderTime = null;
        digitalData.page.SpaApiCallTime = null;
        digitalData.page.startSpaLoad = performance.now();
        digitalData.product = [];
        digitalData.page.attributes.previousPageData.recInfo = {};
        digitalData.page.attributes.featureVariantKeys = [];
        digitalData.lastRefresh = 'soft';
    },

    resetTestAndTarget: function () {
        const Events = require('utils/framework/Events');
        Sephora.Util.InflatorComps.services.loadEvents[Events.TestTargetServiceReady] = false;
        require('services/TestTarget')();
    },

    resetAddStructure: function () {
        require('services/AddStructure')();
    },

    updateHeaderTags: (data, nextPageTemplate) => {
        const template = store.getState().page?.templateInformation?.template;
        const templateToCheck = nextPageTemplate || template;
        const seoParams = templateToCheck === PageTemplateType.ProductPage
            ? data?.content
            : data;

        if (!seoParams) {
            return;
        }

        const {
            seoCanonicalUrl,
            seoMetaDescription,
            seoTitle
        } = seoParams;
        document.title = SpaUtils.getPageTitle(seoTitle, template);

        if (seoTitle) {
            document.getElementById('metaOgTitle')?.setAttribute('content', seoTitle);
        }

        if (seoMetaDescription) {
            document.getElementById('metaDescription')?.setAttribute('content', seoMetaDescription);
            document.getElementById('metaOgDescription')?.setAttribute('content', seoMetaDescription);
        }

        if (seoCanonicalUrl) {
            const url = UrlUtils.getLink(seoCanonicalUrl && DESKTOP + seoCanonicalUrl);
            document.getElementById('seoCanonicalUrl')?.setAttribute('href', url);
            document.getElementById('metaOgUrl')?.setAttribute('content', url);
        }
    },

    getPageTitle: (seoTitle, template) => {
        let title = 'Sephora';

        if (seoTitle) {
            title = seoTitle;
        } else if (LocationUtils.getPageTitle(template)) {
            const postfix = template.indexOf('Community') === -1 ? ' | Sephora' : '';
            title = `${LocationUtils.getPageTitle(template)}${postfix}`;
        }

        return title;
    },

    isSpaNavigation: nextPageUrl =>
        Sephora.isSPA &&
        Sephora.configurationSettings.spaEnabled &&
        SpaUtils.currentPageIsActiveSpaPage() &&
        SpaUtils.nextPageIsActiveSpaPage(nextPageUrl),

    currentPageIsActiveSpaPage: () => {
        const { page: { templateInformation: { template } } } = store.getState();
        const templateInfo = SpaUtils.getSpaTemplateInfoByTemplate(template);
        return SpaUtils.getKillSwitchValueOrDefault(templateInfo, true);
    },

    nextPageIsActiveSpaPage: (nextPageUrl) => {
        const templateInfo = SpaUtils.getSpaTemplateInfoByUrl(nextPageUrl);
        return SpaUtils.getKillSwitchValueOrDefault(templateInfo, true);
    },

    getKillSwitchValueOrDefault: (templateInfo, defaultValue) => {
        const killSwitchName = templateInfo?.killSwitchName;
        const result = killSwitchName && Object.prototype.hasOwnProperty.call(Sephora.configurationSettings, killSwitchName)
            ? Sephora.configurationSettings[killSwitchName]
            : killSwitchName === undefined ? false : defaultValue;
        return result;
    },

    getSpaTemplateInfoByTemplate: template => SpaTemplatesInfo.find(x => x.template === template),

    getSpaTemplateInfoByUrl: pageUrl => SpaTemplatesInfo.find(info =>
        pageUrl.startsWith(info.url) ||
        pageUrl.startsWith(`/ca/fr${info.url}`) ||
        pageUrl.startsWith(`/ca/en${info.url}`)),

    isSpaTemplate: template => SpaTemplatesInfo.some(x => x.template === template)

};

module.exports = SpaUtils;
